module.exports = __webpack_public_path__ + "img/quote.229f54ae.svg";